module.exports = __webpack_public_path__ + "static/media/dbt-logo.3080259d.svg";